import styled from '@emotion/styled';
import Theme from 'App.theme';
import { RowAlignCenter } from 'components/Basic/Basic.styles';
import { FileUploadContainer } from 'components/FileUpload/FileUpload.styles';
import { StatusTile } from 'components/StatusTile/StatusTile';

export const Container = styled.div`
  h2 {
    margin: 0;
    margin-left: 1rem;
  }

  > div {
    margin-bottom: 1rem;
  }
`;

interface PartFormElementProps {
  width?: number;
}

export const FormElement = styled.div<PartFormElementProps>`
  width: 100%;
  max-width: ${props => props.width}rem;
  padding: 0.5rem;
`;

export const FormCheckboxGroup = styled(RowAlignCenter)`
  margin-left: 0.5rem;
`;

export const UploadContainer = styled.div`
  flex: 1;
  display: flex;
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
`;

export const ButtonContainer = styled.div`
  .MuiButtonBase-root {
    font-size: 14px;
    width: 10rem;
    margin-left: 0.5rem;
  }
`;

export const Status = styled(StatusTile)`
  padding: 0.75rem;
  width: 100%;
`;

export const FileUploadRoot = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background-color 0.3s;

  &:hover {
    background-color: ${Theme.greys.GREY0};
  }
`;

export const FileUploadButton = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0.5rem;

  .MuiButtonBase-root {
    font-size: 14px !important;
  }
`;

export const MarginLeftUploadContainer = styled(FileUploadContainer)`
  margin-left: 1rem;
`;

export const DevicePageRowAlignCenter = styled(RowAlignCenter)``;
